import { apiClient } from "lib/axios";

const normalizeApplication = (application) => {
  if (!application) return application;

  return {
    ...application,
    id: application.id || application._id,
  };
};

const normalizeApplicationResponse = (data) => {
  const application =
    data?.application || data?.data?.application || data?.data || data;

  return {
    ...data,
    application: normalizeApplication(application),
  };
};

export const applyClientCreditToInvoice = async (clientId, payload) => {
  const { data } = await apiClient.post(
    `/client-credit-applications/clients/${clientId}/apply`,
    {
      invoiceId: payload.invoiceId,
      amount: payload.amount || null,
      applicationDate: payload.applicationDate,
      reference: payload.reference || null,
      notes: payload.notes || null,
    },
  );

  return normalizeApplicationResponse(data);
};

export const voidClientCreditApplication = async (id, body = {}) => {
  const { data } = await apiClient.post(
    `/client-credit-applications/${id}/void`,
    body,
  );

  return normalizeApplicationResponse(data);
};

export const getClientAvailableCredit = async (clientId) => {
  const { data } = await apiClient.get(
    `/client-credit-applications/clients/${clientId}/available-credit`,
  );

  return data;
};
